var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RouterLink',{staticClass:"ax-home-logo-link",attrs:{"to":_vm.recentsRoute}},[_c('AxIcon',[_c('AxAxureLogo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }